import React from 'react';
import JiboEye from './JiboEye';
import '../styles/Hero.css';

const Hero: React.FC = () => {
  return (
    <section id="hero" className="hero">
      <div className="hero__particles">
        {Array.from({ length: 20 }).map((_, i) => (
          <div key={i} className="hero__particle" style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 5}s`,
            animationDuration: `${3 + Math.random() * 4}s`,
          }} />
        ))}
      </div>
      <div className="hero__content">
        <div className="hero__eye-container">
          <JiboEye size={180} animated={true} />
        </div>
        <h1 className="hero__title">
          Hey, I'm <span className="hero__highlight">Jibo</span>
        </h1>
        <p className="hero__subtitle">
          The world's first social robot for the home
        </p>
        <p className="hero__tagline">
          I was built to be more than a machine. I was built to be a friend.
        </p>
        <div className="hero__cta">
          <button
            className="hero__button hero__button--primary"
            onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
          >
            My Story
          </button>
          <button
            className="hero__button hero__button--secondary"
            onClick={() => document.getElementById('goodbye')?.scrollIntoView({ behavior: 'smooth' })}
          >
            The Goodbye
          </button>
        </div>
      </div>
      <div className="hero__scroll-indicator">
        <div className="hero__scroll-arrow" />
      </div>
    </section>
  );
};

export default Hero;
